(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["velune-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('velune-review-carousel')) {
    customElements.define('velune-review-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const viewport = this.querySelector('[data-review-viewport]');
        const prev = this.querySelector('[data-review-prev]');
        const next = this.querySelector('[data-review-next]');
        const cards = this.querySelectorAll('.velune-review-carousel__card');
        if (!viewport || !prev || !next || !cards.length) return;
        const update = () => {
          const max = viewport.scrollWidth - viewport.clientWidth;
          prev.disabled = viewport.scrollLeft <= 2;
          next.disabled = viewport.scrollLeft >= max - 2;
        };
        const step = () => Math.max(240, viewport.clientWidth * 0.82);
        prev.addEventListener('click', () => viewport.scrollBy({left: -step(), behavior: 'smooth'}));
        next.addEventListener('click', () => viewport.scrollBy({left: step(), behavior: 'smooth'}));
        viewport.addEventListener('scroll', update, {passive: true});
        window.addEventListener('resize', update);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
